import moment from "moment";

export default {
  methods: {
    $currentDate() {
      return moment().format("YYYY-MM-DD");
    },
  },
};
